import React from 'react'

import {getStatusTheme, statusLabel} from '../../../../modes/attendance/attendanceStatusTheme'

type AttendanceV2StatusBadgeProps = {
  status: string
  theme: 'light' | 'dark'
}

const AttendanceV2StatusBadge: React.FC<AttendanceV2StatusBadgeProps> = ({status, theme}) => {
  const styled = getStatusTheme(status, theme)
  return (
    <span
      className='attendance-v2-status-badge d-inline-flex align-items-center rounded-pill px-2 py-1'
      style={{
        fontSize: '0.7rem',
        fontWeight: 600,
        color: styled.color,
        backgroundColor: styled.softBg,
        border: `1px solid ${styled.color}55`,
      }}
    >
      {statusLabel(status)}
    </span>
  )
}

export default AttendanceV2StatusBadge
